import React from 'react';
import { useResizablePanel } from './useResizablePanel';

export function SidebarResizer() {
  const { onPointerDown } = useResizablePanel();

  return (
    <div
      onPointerDown={onPointerDown}
      className="absolute right-0 top-0 h-full w-1.5 cursor-ew-resize"
      style={{ backgroundColor: 'rgba(100,116,139,0.35)', borderTopRightRadius: '0.75rem', borderBottomRightRadius: '0.75rem' }}
      title="Drag to resize"
    />
  );
}
